import React, { useEffect, useState } from "react";
import { callBackend } from "../components/callBackend";
import { Container, Form } from "react-bootstrap";
import DataTable from "../components/DataTable";
import DownloadButton from "../components/DownloadButton";
import EventData from "../data/events.json";
import { HALLS, totalCapacity } from "../data/halls";

const Halls = () => {
	const [hall, setHall] = useState("all");
	const [event, setEvents] = useState("all");
	const [participants, setParticipants] = useState([]);
	const [filteredParticipants, setFilteredParticipants] = useState([]);
	const [tableControls, setTableControls] = useState({
		page: 1,
		length: 100,
		sortField: "_id",
		sortDir: -1,
		search: "",
	});

	const columns = {
		_id: "Serial Number",
		pid: "PID",
		fName: "First Name",
		lName: "Last Name",
		college: "College/School",
		city: "City",
		state: "State/UT",
		hall: "Hall",
	};

	let downloadHeaders = [
		{ label: "PID", key: "pid" },
		{ label: "First Name", key: "fName" },
		{ label: "Last Name", key: "lName" },
		{ label: "Email Address", key: "email" },
		{ label: "Phone Number", key: "phone" },
		{ label: "Gender", key: "gender" },
		{ label: "Date of Birth", key: "dob" },
		{ label: "Name of Institution", key: "college" },
		{ label: "City", key: "city" },
		{ label: "State/UT", key: "state" },
		{ label: "Hall", key: "hall" },
	];

	useEffect(() => {
		// Fetch participants data from backend
		callBackend({
			method: "GET",
			endpoint: "/admin/reportedParticipants/" + hall,
			onSuccess: (data) => {
				console.log(data);
				setParticipants(data.data);
				setFilteredParticipants(data.data);
			},
			onError: (error) => console.error("Error fetching participants:", error),
		});
	}, [hall]);

	const handleEventFilter = (event) => {
		console.log(event);
		if (event === "all") {
			setFilteredParticipants(participants);
			return;
		}
		setFilteredParticipants(
			participants.filter((participant) => {
				if (event <= 3) {
					return participant.events[event].status;
				} else {
					return participant.events[event];
				}
			})
		);
	};

	useEffect(() => {
		if (event) {
			handleEventFilter(event);
		}
	}, [event, hall]);

	const [occupancy, setOccupancy] = useState({});

	useEffect(() => {
		callBackend({
			method: "GET",
			endpoint: "/admin/hallOccupancy",
			onSuccess: (data) => setOccupancy(data.data || {}),
			onError: (error) => console.error("Error fetching occupancy:", error),
		});
	}, [hall]);

	const hallLabel = ([key, h]) =>
		`${h.name} (${occupancy[key] || 0}/${h.capacity})`;
	const hallOptions = {
		all: "All halls",
		N: "No Accomodation",
		...Object.fromEntries(
			Object.entries(HALLS)
				.filter(([, h]) => h.girls)
				.map((e) => [e[0], "Girls - " + hallLabel(e)])
		),
		...Object.fromEntries(
			Object.entries(HALLS)
				.filter(([, h]) => !h.girls)
				.map((e) => [e[0], "Boys - " + hallLabel(e)])
		),
	};

	const eventOptions = {
		all: { name: "All events" },
		...EventData,
	};

	const getTotalCapacity = () => totalCapacity(true) + totalCapacity(false);

	return (
		<Container style={{ marginTop: "20px", marginBottom: "20px" }}>
			<h1 className="text-center">Halls</h1>
			<Form.Group controlId="hallSelect">
				<Form.Control
					as="select"
					value={hall}
					onChange={(e) => {
						setHall(e.target.value);
					}}
				>
					{Object.entries(hallOptions).map(([key, value]) => (
						<option key={key} value={key}>
							{key === "all"
								? `All halls (Girls ${totalCapacity(true)} + Boys ${totalCapacity(false)} = ${getTotalCapacity()})`
								: value}
						</option>
					))}
				</Form.Control>
				<Form.Control
					as="select"
					value={event}
					onChange={(e) => {
						setEvents(e.target.value.name);
						handleEventFilter(e.target.value);
					}}
				>
					{Object.entries(eventOptions).map(([key, value]) => (
						<option key={key} value={key}>
							{value.name}
						</option>
					))}
				</Form.Control>
			</Form.Group>
			<div style={{ marginTop: "2rem" }}>
				{(() => {
					const q = (tableControls.search || "").trim().toLowerCase();
					const searched = q
						? filteredParticipants.filter((p) =>
							Object.values(p || {}).some((v) => {
								if (v === null || v === undefined) return false;
								if (typeof v === "object") {
									try {
										return JSON.stringify(v).toLowerCase().includes(q);
									} catch (e) {
										return false;
									}
								}
								return String(v).toLowerCase().includes(q);
							})
						)
						: filteredParticipants;
					const start = (tableControls.page - 1) * tableControls.length;
					const pageSlice = searched.slice(start, start + tableControls.length);
					return (
						<DataTable
							columns={columns}
							data={pageSlice}
							count={searched.length}
							tableControls={tableControls}
							setTableControls={setTableControls}
							downloadButton={
								<DownloadButton
									endpoint={"/admin/reportedParticipants/" + hall}
									downloadHeaders={downloadHeaders}
								/>
							}
						/>
					);
				})()}
			</div>
		</Container>
	);
};

export default Halls;
